document.addEventListener('DOMContentLoaded', function () {
    const singleProduct = document.querySelector('.single-product-content')
    if (!singleProduct) return
    const buttons = singleProduct.querySelectorAll('.variation-button')
    if (buttons.length === 0) return
    for (const button of buttons) {
        const variationValue = parseFloat(button.dataset.variationValue)
        if (variationValue >= liGlobal.defaultProductQty) {
            button.classList.add('selected')
            button.dispatchEvent(new Event('click', { bubbles: true }))
            // Stop the loop if we found a valid variation
            break
        }
    }
})

function handleVariationSelection(button) {
    const singleProduct = button.closest('.single-product-content')
    if (!singleProduct) return
    const buttons = singleProduct.querySelectorAll('.variation-button')
    if (buttons.length === 0) return
    const variationSelect = singleProduct.querySelector('select#pa_antal')
    const buttonValue = button.dataset.variationValue
    const selectedVariation = singleProduct.querySelector('.selected-variation')

    buttons.forEach((button) => {
        button.classList.remove('selected')
    })
    button.classList.add('selected')
    variationSelect.value = buttonValue
    variationSelect.dispatchEvent(new Event('change', { bubbles: true }))

    if (selectedVariation) {
        selectedVariation.querySelector('.selected-variation-price').textContent =
            button.querySelector('.price').textContent
        selectedVariation.querySelector('.selected-variation-name').textContent = button.dataset.variationValue
    }

    if (typeof window.updateHedgeCalculator === 'function' && button.dataset.variationId) {
        window.updateHedgeCalculator(button.dataset.variationId)
    }
}

document.addEventListener('click', function (e) {
    if (e.target.closest('.variation-button')) {
        handleVariationSelection(e.target.closest('.variation-button'))
    }
})

// Plus/minus-stepper för kvantitetsfältet på single-product (utan häckkalkylator).
// Knapparna renderas i WC:s quantity-input-mall, på vardera sida om inputen.
document.addEventListener('click', function (e) {
    const btn = e.target.closest('.lw-qty-minus, .lw-qty-plus')
    if (!btn) return
    const input = btn.closest('.quantity')?.querySelector('input.qty, input[name="quantity"]')
    if (!input || input.readOnly) return
    e.preventDefault()

    const step = parseFloat(input.step) || 1
    const min = input.min !== '' ? parseFloat(input.min) : 1
    const max = input.max !== '' && parseFloat(input.max) > 0 ? parseFloat(input.max) : Infinity
    let val = parseFloat(input.value)
    if (isNaN(val)) val = min

    val += btn.classList.contains('lw-qty-plus') ? step : -step
    val = Math.min(max, Math.max(min, val))

    input.value = val
    input.dispatchEvent(new Event('change', { bubbles: true }))
})

document.addEventListener('click', function (e) {
    if (e.target.closest('.go-to-reviews')) {
        e.preventDefault()
        const reviews = document.querySelector('#reviews')
        const reviewDetails = reviews.closest('details')
        if (reviewDetails) {
            const rect = reviewDetails.getBoundingClientRect()
            window.scrollTo({
                top: window.scrollY + rect.top - 80,
                behavior: 'smooth',
            })
            reviewDetails.open = true
        }
    }
})
